// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__22bTy","validationTips":"StatementDescriptor_validationTips__3RqNL"};